/**
 * <ActivityGainTile> — ce qu'une activité finie a rapporté, un compteur par tuile (molecule).
 *
 * Les trois compteurs de l'écran de fin d'aujourd'hui (`ActivityFinalizedCongrats`) : l'XP, les
 * pétales, le chrono. Une carte, un glyphe, la valeur en grand, son nom dessous. Ce qui se gagne
 * prend son glyphe PLEIN du jeu (`<GameGlyph>`, le ton du gain) ; le chrono, qui ne se gagne pas,
 * le glyphe de l'interface sur une pastille neutre.
 *
 * Les compteurs ne défilent pas : la valeur arrive écrite (« jamais un chiffre qui bouge »).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { IconBubble } from "../../atoms/icons/IconBubble"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"
import { GAME_GLYPH_SIZE, GameGlyph } from "../GameGlyph"

export type ActivityGainKind = "xp" | "petals" | "chrono"

export type ActivityGainTileProps = {
    kind: ActivityGainKind
    /** La valeur écrite : « +40 », « +12 », « 18:24 ». */
    value: string
    /** Son nom : « XP », « Pétales », « Chrono ». */
    label: string
    testID?: string
}

export function ActivityGainTile(props: ActivityGainTileProps) {
    const { kind, value, label, testID } = props

    return (
        <Card p="3" testID={testID}>
            <Stack gap="2" align="center">
                {kind === "chrono" ? (
                    <IconBubble
                        iconName="stopwatch"
                        size={GAME_GLYPH_SIZE.card}
                        color="surface-subtle"
                        iconColor="text-primary"
                    />
                ) : (
                    <GameGlyph name={kind} size={GAME_GLYPH_SIZE.card} tone="gain" />
                )}
                <Text size="text-2xl" weight="bold" color="text-strong" numberOfLines={1}>
                    {value}
                </Text>
                <Text size="text-sm" color="text-muted" numberOfLines={1}>
                    {label}
                </Text>
            </Stack>
        </Card>
    )
}
